/*
 * cmn.js
 */

//import $ from 'jquery';  //node_modlesの中にあるものを使用探しに行ってくれる
import '../scss/style.scss';
import 'slick-carousel';

$(function () {
/* ==========================================================
!stack
========================================================== */
/* 関数の読み込み
------------------------------------ */
	naviopen();
	pageTop();
	pageTopFixed();
	pageScroll();
	Accordion();
	tabMenu();
	scrollAnimation();
	slider();
	inview();
	modal();
});
/* ==========================================================
!naviopen
========================================================== */
const naviopen = function () {
	var state = false;
	var pos;
	$('.js-menu-toggle').on('click', function () {
		if (state == false) {
			//ハンバーガーが開いていない場合
			pos = $(window).scrollTop();
			$('body').addClass('is-open').css('top', -pos);
			$(this).addClass('is-active');
			$(this).attr('aria-expanded', 'true');
			$(".l-gnavi").fadeIn();
			state = true;
		} else {
			$('body').removeClass('is-open').css('top', 0);
			window.scrollTo(0, pos);
			$(this).attr('aria-expanded', 'false');
			$(this).removeClass('is-active');
			$(".l-gnavi").fadeOut();
			state = false;
		}
	});

	/* window.matchMedia
	------------------------------------ */
	if (window.matchMedia("(max-width:1023px)").matches) {
		// (1)windowの読み込みが完了したときに、767px以下の場合に行いたいもの


	} else {
		// (2)windowの読み込みが完了したときに、768px以上の場合に行いたいもの


	}

	function matchFunction() {
		// (3)windowサイズを変更して、767px以下になったら発火するイベント
		$('body').removeClass('is-open').css('top', 0);
		$('.js-menu-toggle').attr('aria-expanded', 'false');
		$('.js-menu-toggle').removeClass('is-active');
		$(".l-gnavi").fadeOut();

		if (window.matchMedia("(min-width:1024px)").matches) {
			// (4)windowサイズを変更して、768px以上になったら発火するイベント
			$('body').removeClass('is-open').css('top', 0);
			$('.js-menu-toggle').attr('aria-expanded', 'false');
			$('.js-menu-toggle').removeClass('is-active');
			$(".l-gnavi").fadeIn();


		}
	}
	window.matchMedia("(max-width:1023px)").addListener(matchFunction);



};

/* ==========================================================
!pageTop
========================================================== */
const pageTop = function () {
	$(".js-pagetop").on("click", function () {
		$("html, body").animate({ scrollTop: 0 }, 1000);
		return false;
	});
};
/* ==========================================================
!fixed pagetop scroll
========================================================== */
const pageTopFixed = function () {
	const pageTopBox = $(".js-pagetop__fixed");
	const floating = $(".js-floating");

	pageTopBox.on("click", function () {
		$("html, body").animate({ scrollTop: 0 }, 1000, );
		return false;
	});


	$(window).on("scroll", function () {
		if ($(this).scrollTop() > 150) {
			pageTopBox.fadeIn();
			floating.fadeIn();
		} else {
			pageTopBox.fadeOut();
			floating.fadeOut();
		}

		const scrollHeight = $(document).height();
		const scrollPosition = $(window).height() + $(window).scrollTop();
		const footHeight = $("#footer").innerHeight();
		if (scrollHeight - scrollPosition <= footHeight) {
			//pageTopLink.css({ position: "absolute", bottom: "0px" });
		} else {
			//pageTopLink.css({ position: "fixed", bottom: "0px" });
		}
	});

	/* window.matchMedia
	------------------------------------ */
	if (window.matchMedia("(max-width:1023px)").matches) {
		// (1)windowの読み込みが完了したときに、767px以下の場合に行いたいもの


	} else {
		// (2)windowの読み込みが完了したときに、768px以上の場合に行いたいもの
		const info = $(".l-header__info");
		const header = $(".l-header");
		let set_position = 0;

		$(window).on("scroll", function () {
			const windowWidth = window.innerWidth;
			if(windowWidth > 1023){
				if (set_position < $(this).scrollTop()) {
					info.fadeOut();
					header.removeClass("is-scrl");
				} else {
					info.fadeIn().css("display","flex");
					header.addClass("is-scrl");
				}
				set_position = $(this).scrollTop();
			}
		});


	}

	function matchFunction() {
		// (3)windowサイズを変更して、767px以下になったら発火するイベント

		if (window.matchMedia("(min-width:1024px)").matches) {
			// (4)windowサイズを変更して、768px以上になったら発火するイベント

		}
	}
	window.matchMedia("(max-width:1023px)").addListener(matchFunction);


};
/* ==========================================================
!pageScroll
========================================================== */
const pageScroll = function () {
	$("a[href*='#']:not('.inline'), .js-scroll").on("click", function () {
		$("html, body").animate(
			{
				scrollTop: $($.attr(this, "href")).offset().top - 80, // - 70 等といれるとそのピクセル数分増えた状態でスクロールが止まる(ヘッダー固定の時に利用)
			},
			500
		);
	});
};
/* ==========================================================
!Accordion
========================================================== */
const Accordion = function () {
	const accordion01 = $(".js-accordion dt");
	const accordion02 = $(".js-acco");

	// クリックしたとき
	accordion01.on("click", function () {
		$(this).toggleClass("u-active").next().slideToggle();
	});

	// エンターキーを押したとき
	accordion01.on("keyup", function (e) {
		if (e.keyCode == 13) {
			$(this).toggleClass("u-active").next().slideToggle();
		}
	});
	accordion02.on("click", function () {
		$(this).toggleClass("u-active").next().slideToggle();
		return false;
	});

	// エンターキーを押したとき
	accordion02.on("keyup", function (e) {
		if (e.keyCode == 13) {
			$(this).toggleClass("u-active").next().slideToggle();
			return false;
		}
	});

	/* window.matchMedia
	------------------------------------ */
	if (window.matchMedia("(max-width:767px)").matches) {
		// (1)windowの読み込みが完了したときに、767px以下の場合に行いたいもの
		$(".js-acco").removeClass("u-active");


	} else {
		// (2)windowの読み込みが完了したときに、768px以上の場合に行いたいもの


	}

	function matchFunction() {
		// (3)windowサイズを変更して、767px以下になったら発火するイベント
		$(".js-acco").next().hide();
		$(".js-acco").removeClass("u-active");

		if (window.matchMedia("(min-width:768px)").matches) {
			// (4)windowサイズを変更して、768px以上になったら発火するイベント
		$(".js-acco").next().hide();


		}
	}
	window.matchMedia("(max-width:768px)").addListener(matchFunction);

};
/* ==========================================================
!tab
========================================================== */
const tabMenu = function () {
	$(".js-tab").on("click", function () {
		//タブのclassつけ外し
		$(".js-memu-active").removeClass("js-memu-active");
		$(this).addClass("js-memu-active");

		const selectedTabIndex = $(this).parent().index();

		//エリアのclassつけ外し
		$(".js-area-active").removeClass("js-area-active");
		$(".js-tab_area").eq(selectedTabIndex).addClass("js-area-active");
		return false;
	});
};
/* ==========================================================
!Scroll Animation
========================================================== */
const scrollAnimation = function () {
	const AnimTrigger = $(".js-effect"); //アニメーショントリガー
	const windowHeight = $(window).height(); //ウインドウの高さ

	// ロードした際に可視範囲に入っていたら実行される
	$(window).on("load", function () {
		AnimTrigger.each(function () {
			const imgPos = $(this).offset().top; //「AnimTrigger」の位置

			if (imgPos < windowHeight) {
				$(this).addClass("js-aniOn");
			}
		});
	});

	// スクロールした際に「AnimTrigger」ごとに、以下に記述する内容が実行される
	$(window).on("scroll", function () {
		const scroll = $(window).scrollTop(); //スクロールした量

		AnimTrigger.each(function () {
			const imgPos = $(this).offset().top; //「AnimTrigger」の位置

			//アニメーションする条件＝「画面の下から1/5まできた時点でアニメーション」
			if (scroll > imgPos - windowHeight + windowHeight / 5) {
				//スクロール量　が次の条件より多いとき　…　条件：トリガーの場所　引く　ウィンドウの高さ　足す　ウィンドウの高さ　割る　5（- windowHeight + windowHeight / 5 なので6/5でなく4/5）
				$(this).addClass("js-aniOn");
			}
		});
	});
};
/* ==========================================================
!slider
========================================================== */
const slider = function () {
	$(".slider").slick({
		autoplay: true,
		fade: true,
		dots: true,
	});
	$(".slider__case").slick({
		autoplay: false,
		fade: false,
		dots: false,
		slidesToShow: 4,
		infinite: true,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 1800, // 769px以下のサイズに適用
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 769, // 769px以下のサイズに適用
				settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: "8%",
					infinite: true,
				}
			},
		],
	});
	$(".slider__column").slick({
		autoplay: false,
		fade: false,
		dots: false,
		slidesToShow: 4,
		infinite: true,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 1800, // 769px以下のサイズに適用
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 769, // 769px以下のサイズに適用
				settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: "8%",
					infinite: true,
				}
			},
		],
	});
	$(".slider__latest").slick({
		autoplay: false,
		fade: false,
		dots: false,
		slidesToShow: 3,
		infinite: true,
		adaptiveHeight: true,
		responsive: [
			{
				breakpoint: 769, // 769px以下のサイズに適用
				settings: {
					slidesToShow: 1,
					centerMode: true,
					centerPadding: "8%",
					infinite: true,
				}
			},
		],
	});
	// 製品詳細スライダー
	$(".slider__product").slick({
		autoplay: false, // 自動再生ON
		arrows: true, // 矢印非表示
		asNavFor: ".slider__thumbnail", // サムネイルと同期
	});
	// サムネイルのオプション
	$(".slider__thumbnail").slick({
		slidesToShow: 3, // サムネイルの表示数
		asNavFor: ".slider__product", // メイン画像と同期
		focusOnSelect: true, // サムネイルクリックを有効化
	});
	let choice = $(".js-choice");
	choice.eq(0).addClass("is-active");
	choice.on('click',function(){
		const index = $(this).index();
		choice.removeClass("is-active");
		$(this).addClass("is-active");
		$(".slider__product").slick("slickGoTo", index, false);
		return false;
	});


	const dotsize = $(".slick-dots").width() / 2 + 20;
	$(".slider__pause").css("transform", "translateX(" + dotsize + "px)");
	$(".js-sliderpause").on("click", function() {
		//一時停止中なら
		if($(this).hasClass("paused")){
			//再開
			$(".slider").slick("slickPlay");
			//「.paused」削除
			$(this).removeClass("paused");
			$(this).children("span").html("停止する");
		}else{
			//再生中なら
			//一時停止
			$(".slider").slick("slickPause");
			//「.paused」付与
			$(this).addClass("paused");
			$(this).children("span").html("再生する");
		}
	});

};

/* ==========================================================
!inview
========================================================== */
const inview = function () {

	$(document).ready(function () {
			if (window.performance.navigation.type == 1 || 2) {
				$(".js-fadein").each(function(){
					var position = $(this).offset().top;
					var scroll = $(window).scrollTop();
					var windowHeight = $(window).height();
					if (scroll > position - windowHeight + 100){
						$(this).addClass('is-active');
					}
				});
			}
	});

	$(window).scroll(function (){
		$(".js-fadein").each(function(){
			var position = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > position - windowHeight + 100){
				$(this).addClass('is-active');
			}
		});
	});

};

/* ==========================================================
!modal
========================================================== */
const modal = function () {

	$(".js-modal").on("click", function(){
		$(".p-modal__mask").fadeIn();
		$(".p-modal").fadeIn();
		return false;
	});

	$(".js-modal-close").on("click", function(){
		$(".p-modal__mask").fadeOut();
		$(".p-modal").fadeOut();
		return false;
	});

};
